import { mapActions } from 'vuex';
import useVuelidate from '@vuelidate/core';
import { ToastProgrammatic as Toast } from 'buefy';

import StoreForm from '@/components/Store/StoreForm/StoreForm.vue';
import MenuList from '@/components/Store/MenuList/MenuList.vue';
import { STORE_MODES } from '@/utils/constants';
import {
  CREATE_STORE,
  UPDATE_STORE,
  GET_STORE,
  GET_MENU_LIST,
} from '@/store/store/constants';

export default {
  name: 'StoreEditor',
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    StoreForm,
    MenuList,
  },
  data() {
    return {
      loading: false,
      store: undefined,
      menus: [],
    };
  },
  computed: {
    mode() {
      return this.$route.params.action || STORE_MODES.CREATE;
    },
    isCreateMode() {
      return this.mode === STORE_MODES.CREATE;
    },
    isEditMode() {
      return this.mode === STORE_MODES.EDIT;
    },
    pathToCreateMenu() {
      return `/store/${this.$route.params.storeId}/menu/`;
    },
    isMenuActionAvailable() {
      return this.isEditMode;
    },
  },
  async mounted() {
    if (!this.isEditMode) {
      return;
    }

    const { storeId } = this.$route.params;

    if (!storeId) {
      Toast.open({
        type: 'is-warning',
        message: '無法取得店家資訊，請再試一次',
      });
      this.$router.go(-1);
      return;
    }

    try {
      this.loading = true;
      this.store = await this.getStore(storeId);
      this.menus = await this.getMenuList(storeId);
    } catch {
      Toast.open({
        type: 'is-danger',
        message: '取得店家資料時發生錯誤，請再試一次',
      });
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async saveStore(storeInfo) {
      try {
        let store = {};

        this.loading = true;
        if (this.isCreateMode) {
          store = await this.createStore(storeInfo);
          this.store = store;
        } else {
          if (!storeInfo.id) {
            throw new Error();
          }
          await this.updateStore({ storeId: storeInfo.id, payload: storeInfo });
        }
        const storeId = store?.id || storeInfo.id;
        Toast.open({
          type: 'is-success',
          message: '店家資訊已儲存',
        });
        if (!this.isEditMode) {
          this.$router.push(`/store/${storeId}/edit`);
        }
      } catch (ex) {
        const mode = this.isCreateMode ? '新增' : '編輯';
        Toast.open({
          type: 'is-danger',
          message: `${mode}店家時發生錯誤，請稍候重試一次`,
        });
      } finally {
        this.loading = false;
      }
    },
    ...mapActions('store', {
      createStore: CREATE_STORE,
      updateStore: UPDATE_STORE,
      getStore: GET_STORE,
      getMenuList: GET_MENU_LIST,
    }),
  },
};
